import { ProjectService } from './../../services/project.service';
import { Component } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { SharedDataService } from 'src/app/core-features/shared/shared.service';
// import { IProject } from '../../interfaces/project.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import { CreateProjectComponent } from '../../component/create-project/create-project.component';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Router } from '@angular/router';

@Component({
  selector: "app-project-list",
  templateUrl: "./project-list.component.html",
  styleUrls: ["./project-list.component.scss"]
})
export class ProjectListComponent {
  
  public isDelete: boolean = false;
  public title: string;
  public items: any;
  public isLoading: boolean = true;
  public totalRecords: number;
  // public selectedItems: IProject [];
  // public projectId: number;
  public submitting: boolean = false;
  public  accessDeniede = false;
  public keyword: any="";
  public pageNo: any=1;
  public pageSize: any=10;
  reloadPagination: boolean;
  
  constructor(
    private projectDataService: ProjectService,
    private toastr: ToastrService,
    private SharedDataService: SharedDataService,
    private primengConfig: PrimeNGConfig,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllProjects(1, 10,this.keyword);
    this.primengConfig.ripple = true;
  }

  // For Dynamic Pagination
  paginate(event) {
    this.pageNo=event.page+1;
    this.pageSize=event.rows;
this.getAllProjects(event.page+1, event.rows,this.keyword); // pageNo = event.page+1, pageSize = event.rows
  }
  // For server side Search/Filter
  onFilter($event:any) {
    
    this.isLoading = true;
    this.keyword = $event.target.value;
    this.reloadPagination=true;
    this.getAllProjects(1, 10, this.keyword);
  }
  getAllProjects(pNo, pSize,key:any){
    
    this.projectDataService.getAll(pNo, pSize,key).subscribe(
      (res) => {
        this.totalRecords = res.body['totalElements'];
        this.items = res.body["data"];
        this.isLoading = false;
        this.reloadPagination=false;
      },
      (error) => {
        this.reloadPagination=false;
        if (error.error.statusCode == 403) {
          this.accessDeniede = true;
          this.toastr.error("", "Access denied");
        } else if (error.error.statusCode == 401) {
          this.router.navigate(['/auth/login']);
        } else if (error.error.statusCode == 0) {
          this.toastr.error("", "Something Went Wrong");
        } else {
          this.toastr.error("", error.error.message);
        }
      }
    );
  }
  
  
   showDeleteOption(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "Caution! You are about to delete the following project!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.isDelete = true;
        this.reloadPagination=true;
        this.removeProject(id);
        Swal.fire(
          'Deleted!',
          'Your project has been deleted.',
          'success'
        )
      }
    })
  }

  // Delete Project
  removeProject(id: any) {
    this.submitting = true;
    this.projectDataService.delete(id).subscribe(
      (res) => {
        this.toastr.success("", "Successfully deleted");
        this.isDelete = false;
        this.submitting = false;
        this.getAllProjects(1, 10,this.keyword);
      },
      (error) => {
        if (error.error.statusCode == 403) {
          this.toastr.error("", "Access denied");
        } else if (error.error.statusCode == 401) {
          this.router.navigate(['/auth/login']);
        } else if (error.error.statusCode == 0) {
          this.toastr.error("", "Something Went Wrong");
        } else {
          this.toastr.error("", error.error.message);
        }
        this.submitting = false;
      }
    );
  }

  //Project Modal
  public editDialog(id:any){

   let tempData:any={};
   if(id == null || id == undefined){
    tempData.title = "Add Project";
    tempData.type = "Register"
   }
  else {
    tempData.title = "Update Project";
    tempData.type = "Update"
    let projectObj = this.items.find((x) => x.id == id);
    tempData.data = projectObj;
  }

   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width="700px";
   dialogConfig.data = tempData;
   
   const dialogRef= this.dialog.open(CreateProjectComponent, dialogConfig);

   dialogRef.afterClosed().subscribe(res=>{
    if(res=='unchanged'){

    }else{
      this.reloadPagination=true;
        this.getAllProjects(1, 10,this.keyword);
    }
    

   })
 } 

}


